import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CardSection(_ref) {
  let {
    title = "",
    className = "",
    children
  } = _ref;
  return /*#__PURE__*/_jsxs("section", {
    className: className,
    children: [title && /*#__PURE__*/_jsx("h3", {
      className: "mb-2 text-dark-blue",
      children: title
    }), children]
  });
}
CardSection.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  title: PropTypes.string
};
export default CardSection;
//# sourceMappingURL=CardSection.js.map